import {
  Box,
  Button,
  Grid,
  Modal,
  Tab,
  Tabs,
} from "@mui/material";
import dayjs from "dayjs";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { RHFTextField } from "../../RHFComponents/RHFComponents";
import { panoteg } from "../../../networking";
import { AllertMessage } from "../../DoctorsList/Medint/MedintDetails/MedintDetails";
import { CalendarInfo } from "./Calendar";

type StateFormNoteGiornaliere = {
  data: string;
  note: string;
};

export const DailyNoteOption = (props: {
  calendarInfo: CalendarInfo;
  dataGiornoSelezionato: any;
  setDataGiornoSelezionato: Dispatch<SetStateAction<any>>;
  showOptionNoteGiornaliere: boolean;
  setShowOptionNoteGiornaliere: Dispatch<SetStateAction<boolean>>;
  oggettoNotaSelezionato: any;
  onBookingComplete: () => void;
  onNoteSaved?: (args: { date: string; text: string; id?: string }) => void; //Prop per le note giornaliere
}) => {
  // Allert di conferma/risultato
  const [showAllert, setShowAllert] = useState(false);
  const [severity, setSeverity] = useState<"warning" | "success" | "error">(
    "warning"
  );
  const [message, setMessage] = useState("");

  // L'alert si chiude dopo 4 secondi se non è di tipo warning
  useEffect(() => {
    if (showAllert && severity !== "warning") {
      const t1 = setTimeout(() => setShowAllert(false), 4000);
      return () => {
        clearTimeout(t1);
      };
    }
  }, [severity]);

  useEffect(() => {
    if (severity !== "warning") {
      const t2 = setTimeout(() => {
        setSeverity("warning");
        setMessage("");
      }, 4000);
      return () => {
        clearTimeout(t2);
      };
    }
  }, [showAllert]);

  const methodsFormNoteGiornaliere = useForm<StateFormNoteGiornaliere>({
    defaultValues: {
      data: props?.dataGiornoSelezionato,
      note: props?.oggettoNotaSelezionato?.testo ?? "",
    },
  });

  // funzione send json note giornaliere
  const requestUpdateNoteGiornaliere = async (data: any) => {
    try {
      const payload: any = props?.oggettoNotaSelezionato?.id
        ? {
            crud: "U",
            medico: props.calendarInfo.codiceMedico,
            idNota: props?.oggettoNotaSelezionato.id,
            testoNota: data.note,
            aziendaPrenotazione: props.calendarInfo.aziendaPrenotazione,
          }
        : {
            crud: "C",
            medico: props.calendarInfo.codiceMedico,
            data: data.data,
            testoNota: data.note,
            aziendaPrenotazione: props.calendarInfo.aziendaPrenotazione,
          };

      const response = await panoteg(payload);
      console.log("Risposta dal server:", response);
      if (response.data.esito === "OK") {
        setSeverity("success");
        setMessage(response.data.messaggio);
        props.setShowOptionNoteGiornaliere(false);

        //callback per Calendar per ricaricare le note giornaliere
        props.onNoteSaved?.({
          date: data.data,
          text: data.note,
          id: props?.oggettoNotaSelezionato?.id,
        });
      } else {
        setSeverity("error");
        setMessage(response.data.messaggio);
      }
    } catch (err) {
      console.error("Errore fetch datiPacada:", err);
    } finally {
      setShowAllert(true);
    }
  };

  const onSubmitFormNoteGiornaliere = (data: StateFormNoteGiornaliere) => {
    requestUpdateNoteGiornaliere(data);
  };

  return (
    <>
      <AllertMessage
        showAllert={showAllert}
        setShowAllert={setShowAllert}
        severity={severity}
        message={message}
      />
      <Modal open={props.showOptionNoteGiornaliere}>
        <Box
          sx={{
            maxHeight: "90vh",
            maxWidth: "80vh",
            width: "85%",
            overflow: "auto",
            paddingTop: 2,
            backgroundColor: "white",
            borderRadius: 2,
            boxShadow: 24,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Tabs value={0} sx={{ paddingLeft: 2, mb: 2 }}>
            <Tab
              sx={{
                fontFamily: "Montserrat",
                fontWeight: "bold",
                textTransform: "none",
              }}
              label="Note giornaliere"
            />
          </Tabs>

          <form
            onSubmit={methodsFormNoteGiornaliere.handleSubmit(
              onSubmitFormNoteGiornaliere
            )}
          >
            <Grid container spacing={2} padding={2} justifyContent="center">
              <Grid item xs={5}>
                <RHFTextField
                  control={methodsFormNoteGiornaliere.control}
                  name="data"
                  label="Giorno"
                  placeholder="Inserire Data"
                  required
                  disabled
                  inputProps={{
                    min: dayjs().format("YYYY-MM-DD"),
                    max: "9999-12-31",
                  }}
                  type="date"
                  fullWidth
                  size="small"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
              <Grid item xs={7}></Grid>
              <Grid item xs={12}>
                <RHFTextField
                  control={methodsFormNoteGiornaliere.control}
                  name="note"
                  label="Note"
                  placeholder="Note eventuali"
                  fullWidth
                  multiline
                  rows={4}
                  required
                  inputProps={{ maxLength: 400 }}
                  helperText={
                    (methodsFormNoteGiornaliere.watch("note")?.length ?? 0) +
                    "/400"
                  }
                  rules={{
                    required: "Campo obbligatorio",
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between">
                  <Button
                    variant="outlinedError"
                    onClick={() => {
                      props.setShowOptionNoteGiornaliere(false);
                      props.setDataGiornoSelezionato("");
                      methodsFormNoteGiornaliere.reset();
                    }}
                  >
                    Uscita
                  </Button>

                  <Button type="submit" variant="contained">
                    Conferma
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </Modal>
    </>
  );
};
